/*
 * File: parser.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 22, 2025 at 12:33 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 26, 2025 at 2:34 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import { Children, isValidElement } from 'react';


/**
 * Utilities
 */

export const parseMarkdownLinks = (content) => {

	// Define markdown link regex
	const markdownRegex = /\[([^[]+)\](\(([^)]*))\)/gim;

	// Parse links
	return content.replace(markdownRegex, '<a href="$3">$1</a>');
};

export const isValidNode = () => true;

export const parseTitleFromChildren = (children, t) => {

	// If children is a string or number, return it directly
	if (typeof children === 'string' || typeof children === 'number') {
		return children.toString();
	}

	// If children is a valid React element, recurse through its children
	if (isValidElement(children)) {
		let text = '';

		// Check if i18n component
		if (children.props.i18nKey) {

			// Get data for translation
			let data = {};
			if (children.props.children && Array.isArray(children.props.children)) {
				children.props.children.forEach((c) => {
					if (typeof c === 'object') {
						data = { ...data, ...c };
					}
				});
			}

			// Return translation
			return t(children.props.i18nKey, data);
		}

		// Traverse through the children (props.children can be a single element or array)
		Children.forEach(children.props.children, (child) => {
			text += ` ${parseTitleFromChildren(child, t)}`;
		});

		// Return text
		return text.trim();
	}

	// If children is an array, recursively render each element
	if (Array.isArray(children)) {
		const rendered = children.map((child) => parseTitleFromChildren(child, t));
		return rendered.reduce((a, b) => (a.length > b.length ? a : b));
	}

	// If children is neither text nor a React element, return an empty string
	return '';
};
